import { ISimpleTableField, simpleTableSortFn } from "@asup/simple-table";
import { RenderReleaseStatus } from "../RenderReleaseStatus";
import { TlfItemTableLinkCell } from "../TlfItemTableLinkCell";
import { filterTemplates } from "./filterTemplates";
import { searchTemplatesWithText } from "./searchTemplatesWithText";

// Template columns
export const SearchResultsHeaders: ISimpleTableField[] = [
  {
    name: "azsolIdVersion",
    label: "AZSOL ID/Version",
    width: "130px",
    sortFn: simpleTableSortFn,
    searchFn: searchTemplatesWithText,
    filterOutFn: filterTemplates,
    renderFn: TlfItemTableLinkCell,
    canColumnFilter: true,
  },
  {
    name: "releaseStatus",
    label: "Status",
    width: "80px",
    sortFn: simpleTableSortFn,
    canColumnFilter: true,
    renderFn: RenderReleaseStatus,
  },
  {
    name: "tocLabel",
    label: "Title",
    width: "600px",
    canColumnFilter: true,
    sortFn: simpleTableSortFn,
  },
  {
    name: "additionalInformation",
    label: "Additional information",
    width: "800px",
    canColumnFilter: true,
    sortFn: simpleTableSortFn,
  },
];

// ToC item columns
export const SearchTocHeaders: ISimpleTableField[] = [
  {
    name: "taPrefix",
    label: "TA",
    width: "100px",
    canColumnFilter: true,
    sortFn: simpleTableSortFn,
  },
  {
    name: "projectCode",
    label: "Project",
    width: "100px",
    canColumnFilter: true,
    sortFn: simpleTableSortFn,
  },
  {
    name: "dNumber",
    label: "D Number",
    width: "100px",
    sortFn: simpleTableSortFn,
    canColumnFilter: true,
    searchFn: searchTemplatesWithText,
  },
  {
    name: "tocNumber",
    label: "ToC Number",
    width: "100px",
    sortFn: simpleTableSortFn,
    renderFn: TlfItemTableLinkCell,
    canColumnFilter: true,
  },
  {
    name: "tocLabel",
    label: "Title",
    width: "600px",
    canColumnFilter: true,
    sortFn: simpleTableSortFn,
  },
  {
    name: "additionalInformation",
    label: "Additional information",
    width: "800px",
    canColumnFilter: true,
    sortFn: simpleTableSortFn,
  },
];
